import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

export const HELP_CENTER_URL =
  'https://nemetschekprime.atlassian.net/helpcenter/ocp/page/d0d3c522/Open+Collaboration+Platform+Early+Access+Portal';

@Component({
  selector: 'ocp-getting-started',
  imports: [TranslatePipe, ThemedIconComponent],
  templateUrl: './getting-started.component.html',
  styleUrl: './getting-started.component.scss',
})
export class GettingStartedComponent {
  readonly helpCenterUrl = HELP_CENTER_URL;
  readonly showInfoCard = input(true);
  readonly showSetupCard = input(true);
}
